import {
  PRE_MUTATE_EFT_ACCOUNT_NUMBER_REGXP,
  PRE_MUTATE_INSTITUTION_NUMBER_REGXP,
  PRE_MUTATE_BRANCH_NUMBER_REGXP,
} from '../../../constants/patterns';

export default function payoutEftPreMutate(formData, key, value) {
  switch (key) {
    case 'accountNumber':
      return PRE_MUTATE_EFT_ACCOUNT_NUMBER_REGXP.test(value);

    case 'institutionNumber':
      return PRE_MUTATE_INSTITUTION_NUMBER_REGXP.test(value);

    case 'branchNumber':
      return PRE_MUTATE_BRANCH_NUMBER_REGXP.test(value);

    default:
  }

  return true;
}
